// import React, { useState, useEffect, useContext } from "react";
// import DataTable from "react-data-table-component";
// import AuthContext from "../../contexts/AuthContext";
// import "./contact-us-details.css";

// const ContactUsDetails = () => {
//   const { token } = useContext(AuthContext);

//   const [contacts, setContacts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRows, setTotalRows] = useState(0);

//   const [searchFilters, setSearchFilters] = useState({
//     userName: "",
//     userEmail: "",
//     userPhoneNo: "",
//     fromDate: "",
//     toDate: "",
//   });

//   useEffect(() => {
//     fetchContacts();
//   }, [page, pageSize, searchFilters]);

//   const fetchContacts = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/contact/search`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             ...searchFilters,
//             pageNo: page,
//             pageSize,
//           }),
//         }
//       );

//       const data = await response.json();
//       setContacts(data?.data || []);
//       setTotalRows(data?.totalResult || 0);
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (newPageSize, newPage) => {
//     setPageSize(newPageSize);
//     setPage(newPage); // keeps pagination consistent
//   };

//   const columns = [
//     {
//       name: "Name",
//       selector: (row) => row?.userName || "-",
//       sortable: true,
//     },
//     {
//       name: "Email",
//       selector: (row) => row?.userEmail || "-",
//       sortable: true,
//     },
//     {
//       name: "Phone",
//       selector: (row) => row?.userPhoneNo || "-",
//       sortable: true,
//     },
//     {
//       name: "Message",
//       cell: (row) => (
//         <div className="order-id-cell" title={row?.userMessage}>
//           {row?.userMessage}
//         </div>
//       ),
//     },
//     {
//       name: "Date",
//       selector: (row) => row?.createdDate || "-",
//       sortable: true,
//     },
//   ];

//   return (
//     <main className="contact-us-details py-3">
//       <div className="our-container">
//         <div className="inner-container">
//           <section className="contact-us-details-main-block">
//             <div className="contact-us-details-header">
//               <h1>Contact Us Details</h1>
//             </div>
//           </section>

//           <div className="contact-us-details-body">
//             <DataTable
//               columns={columns}
//               data={contacts}
//               progressPending={loading}
//               pagination
//               paginationServer
//               paginationTotalRows={totalRows}
//               paginationPerPage={pageSize}
//               onChangePage={handlePageChange}
//               onChangeRowsPerPage={handleRowsPerPageChange} // ✅ FIX
//               highlightOnHover
//             />
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default ContactUsDetails;


import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { FiDownload, FiEye, FiX } from "react-icons/fi";
import AuthContext from "../../contexts/AuthContext";
import AdminLayout from "../../layouts"; // Ensure this is wrapped if needed
import "./contact-us-details.css";

const ContactUsDetails = () => {
  const { token, triggerSessionExpired } = useContext(AuthContext);

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);

  // 1. Temporary state for input fields
  const [filters, setFilters] = useState({
    userName: "",
    userEmail: "",
    phoneNo: "",
    fromDate: "",
    toDate: "",
  });

  // 2. State that actually triggers the API fetch
  const [activeSearch, setActiveSearch] = useState({});

  useEffect(() => {
    fetchContacts();
  }, [page, pageSize, activeSearch]);

  // Lets the detail modal be dismissed with Escape, matching standard modal UX.
  useEffect(() => {
    if (!selectedContact) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setSelectedContact(null);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [selectedContact]);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/contact/search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...activeSearch,
            pageNo: page,
            pageSize,
          }),
        }
      );

      if (response.status === 401 || response.status === 403) {
        triggerSessionExpired();
        return;
      }

      const data = await response.json();
      setContacts(data?.data || []);
      setTotalRows(data?.totalResult || 0);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    setPage(1); // Reset to first page on new search
    setActiveSearch(filters);
  };

  const handleClear = () => {
    const emptyFilters = {
      userName: "",
      userEmail: "",
      phoneNo: "",
      fromDate: "",
      toDate: "",
    };
    setFilters(emptyFilters);
    setActiveSearch(emptyFilters);
  };

  // Exports ALL rows matching the current filters, not just the loaded page —
  // fetches a fresh copy with pageSize = totalRows so the CSV matches what the
  // search/filter says is there, not just what's rendered in the table.
  const handleExport = async () => {
    if (!totalRows) {
      toast.info("No data to export.");
      return;
    }

    setExporting(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/contact/search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...activeSearch,
            pageNo: 1,
            pageSize: totalRows,
          }),
        }
      );

      if (response.status === 401 || response.status === 403) {
        triggerSessionExpired();
        return;
      }

      const data = await response.json();
      const allRows = data?.data || [];

      if (!allRows.length) {
        toast.info("No data to export.");
        return;
      }

      const headers = ["Name", "Email", "Phone", "Message", "Date"];

      const escapeCell = (val) => {
        const str = val === null || val === undefined ? "" : String(val);
        // Wrap in quotes and escape any embedded quotes for CSV safety.
        return `"${str.replace(/"/g, '""')}"`;
      };

      const rows = allRows.map((row) =>
        [row?.userName, row?.userEmail, row?.userPhoneNo, row?.userMessage, row?.createdDate]
          .map(escapeCell)
          .join(",")
      );

      const csvContent = [headers.map(escapeCell).join(","), ...rows].join("\r\n");

      const blob = new Blob(["﻿" + csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `contact-us-details-${new Date().toISOString().slice(0, 10)}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting contacts:", error);
      toast.error("Failed to export data. Please try again.");
    } finally {
      setExporting(false);
    }
  };

  const columns = [
    { name: "Name", selector: (row) => row?.userName || "-", sortable: true },
    { name: "Email", selector: (row) => row?.userEmail || "-", sortable: true },
    { name: "Phone", selector: (row) => row?.userPhoneNo || "-", sortable: true },
    {
      name: "Message",
      cell: (row) => (
        <div className="order-id-cell" title={row?.userMessage}>
          {row?.userMessage}
        </div>
      ),
    },
    { name: "Date", selector: (row) => row?.createdDate || "-", sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <button
          type="button"
          className="action-view-btn"
          onClick={() => setSelectedContact(row)}
          aria-label="View details"
        >
          <FiEye size={16} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "90px",
    },
  ];

  // Themes the table to match the panel's premium redesign (brand-gradient
  // header row, softer hover tint) without touching react-data-table-component's markup.
  const tableCustomStyles = {
    headRow: {
      style: {
        background: "var(--admin-bg)",
        minHeight: "52px",
        borderBottom: "1px solid var(--admin-border)",
      },
    },
    headCells: {
      style: {
        color: "var(--admin-text-primary)",
        fontSize: "13px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.03em",
      },
    },
    rows: {
      style: {
        minHeight: "54px",
        fontSize: "14px",
        color: "#29282b",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0, 180, 255, 0.08)",
        borderBottomColor: "#e4e7ee",
        outline: "none",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #eef0f5",
      },
    },
  };

  return (
    <AdminLayout>
      <div className="contact-us-details">
        <div className="page-banner">
          <div className="page-banner-text">
            <span className="page-banner-tag">Enquiries</span>
            <h1 className="page-banner-title">Contact Us Details</h1>
          </div>
          <div className="page-banner-badge">
            <span className="page-banner-badge-label">Total</span>
            <span className="page-banner-badge-value">{totalRows}</span>
          </div>
        </div>

        {/* --- SEARCH FILTER UI SECTION --- */}
        <div className="search-filter-card">
          <div className="search-grid">
            <div className="filter-group">
              <label>Name:</label>
              <input
                type="text"
                name="userName"
                placeholder="Enter Name"
                value={filters.userName}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>Email:</label>
              <input
                type="email"
                name="userEmail"
                placeholder="Enter Email"
                value={filters.userEmail}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>Phone No:</label>
              <input
                type="text"
                name="phoneNo"
                placeholder="Enter Phone No"
                value={filters.phoneNo}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>From Date:</label>
              <input
                type="date"
                name="fromDate"
                value={filters.fromDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>To Date:</label>
              <input
                type="date"
                name="toDate"
                value={filters.toDate}
                onChange={handleInputChange}
              />
            </div>
          </div>
          
          <div className="search-actions">
            <button className="btn-search" onClick={handleSearch}>Search</button>
            <button className="btn-clear" onClick={handleClear}>Clear</button>
            <button className="btn-export" onClick={handleExport} disabled={exporting}>
              <FiDownload size={16} />
              {exporting ? "Exporting..." : "Export"}
            </button>
          </div>
        </div>

        {/* --- DATA TABLE SECTION --- */}
        <div className="contact-us-details-body">
          <DataTable
            columns={columns}
            data={contacts}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={pageSize}
            onChangePage={(p) => setPage(p)}
            onChangeRowsPerPage={(ps, p) => {
              setPageSize(ps);
              setPage(p);
            }}
            highlightOnHover
            customStyles={tableCustomStyles}
          />
        </div>
      </div>

      {selectedContact && (
        <div
          className="detail-modal-overlay"
          onClick={() => setSelectedContact(null)}
        >
          <div className="detail-modal" onClick={(e) => e.stopPropagation()}>
            <div className="detail-modal-header">
              <h3>Contact Enquiry Details</h3>
              <button
                type="button"
                className="detail-modal-close"
                onClick={() => setSelectedContact(null)}
                aria-label="Close"
              >
                <FiX size={20} />
              </button>
            </div>
            <div className="detail-modal-body">
              <div className="detail-row">
                <span className="detail-label">Name</span>
                <span className="detail-value">{selectedContact?.userName || "-"}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Email</span>
                <span className="detail-value">{selectedContact?.userEmail || "-"}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Phone</span>
                <span className="detail-value">{selectedContact?.userPhoneNo || "-"}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Message</span>
                <span className="detail-value">{selectedContact?.userMessage || "-"}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Date</span>
                <span className="detail-value">{selectedContact?.createdDate || "-"}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default ContactUsDetails;